import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import TextLabel, { ColorType, SizeType, WeightType } from '../../atoms/TextLabel/TextLabel'
import RankingTitle from '../../molecules/RankingTitle/RankingTitle'
import LargeTitle from '../../atoms/LargeTitle/LargeTitle'
import QuizScore from '../../molecules/QuizScore/QuizScore'

import './RankingResult.css'
import Confetti from '../../atoms/Confetti/Confetti'

const RankingResult = ({ rank, name, correctCount, time }) => (
  <div styleName="container">
    {rank === 1 ? (
      <div styleName="confetti">
        <Confetti />
      </div>
    ) : null}
    <div styleName="l-title">
      <TextLabel color={ColorType.MODEST} size={SizeType.TINY} weight={WeightType.NORMAL}>
        結果発表
      </TextLabel>
    </div>
    <div styleName="l-content">
      <div styleName="l-ranking">
        <RankingTitle rank={rank} />
      </div>
      <div styleName="l-name">
        <LargeTitle size={SizeType.MEDIUM} weight={WeightType.HEAVY}>
          {name}
        </LargeTitle>
      </div>
      <div styleName="l-score">
        <QuizScore correctCount={correctCount} time={time} />
      </div>
    </div>
  </div>
)

RankingResult.propTypes = {
  rank: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  correctCount: PropTypes.number.isRequired,
  time: PropTypes.number.isRequired
}

export default compose(pure)(RankingResult)
